import { inputClasses, outlinedInputClasses } from '@mui/material';
import { textInputColors } from '../constants';
const styleOverrides = {
  root: {
    [`&.${inputClasses.root}:before`]: {
      borderBottom: `1px solid ${textInputColors.border}`
    },
    [`&.${inputClasses.root}.${inputClasses.disabled}:before`]: {
      borderBottomStyle: 'solid',
      borderColor: textInputColors.borderDisabled
    },
    [`&.${inputClasses.root}:not(.${inputClasses.disabled}):hover:before`]: {
      borderColor: textInputColors.borderHover
    },
    [`&.${outlinedInputClasses.root}.${outlinedInputClasses.disabled} .${outlinedInputClasses.notchedOutline}`]: {
      borderColor: textInputColors.borderDisabled
    }
  },
  input: {
    '&&:-webkit-autofill': {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0
    },
    [`&.${inputClasses.disabled}`]: {
      WebkitTextFillColor: textInputColors.contentDisabled
    }
  }
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiInputBase.js.map